import { Client } from '../../pure-js/types/GrooverTypes'
import {
  DEFAULT_PUBLIC_ACTIVITIES_THEME,
  DARK_MODE_PRESETS,
  getDarkModeTheme,
  PublicActivitiesThemeConfig,
  resolveActivityHoverBackground,
  resolvePublicActivitiesThemeConfig
} from '../../pure-js/libs/PublicActivitiesThemeHelper'

export type ThemeConfig = PublicActivitiesThemeConfig
export type { DarkModePreset } from '../../pure-js/libs/PublicActivitiesThemeHelper'
export { DARK_MODE_PRESETS, getDarkModeTheme, resolveActivityHoverBackground, resolvePublicActivitiesThemeConfig }

export const defaultTheme: ThemeConfig = { ...DEFAULT_PUBLIC_ACTIVITIES_THEME }

export let themeConfig: ThemeConfig = { ...defaultTheme }

export const getThemeConfig = () => themeConfig

export const setThemeConfig = (client: Client) => {
  themeConfig = resolvePublicActivitiesThemeConfig(client)
}

/** Write a fully resolved theme (e.g. after URL darkModePreset override) into the module store. */
export const setResolvedThemeConfig = (theme: ThemeConfig) => {
  themeConfig = theme
}
